export default __webpack_public_path__ + "b2546f4b6cf4011784d9f49b40e8ea2c.svg";